import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import SectionLabel from '../components/SectionLabel';
import { portfolio } from '../mock/data';
import { useLang } from '../i18n/LanguageContext';
import { Reveal } from '../hooks/useReveal';

export default function Portfolio() {
  const { t } = useLang();
  return (
    <main className="pt-32 lg:pt-40 pb-24 bg-cream">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <Reveal variant="up" className="mb-10 lg:mb-12">
          <div data-stagger="0"><SectionLabel>{t('portfolioPage.eyebrow')}</SectionLabel></div>
          <h1 data-stagger="1" className="font-serif-display text-5xl md:text-6xl lg:text-7xl leading-[0.95] text-dark">
            {t('portfolioPage.title')}
          </h1>
        </Reveal>

        <Reveal variant="up" className="border-y border-warm py-6 mb-12 max-w-3xl">
          <p className="text-[15px] text-muted-warm leading-relaxed font-light">
            {t('portfolioPage.note')}
          </p>
        </Reveal>

        <Reveal variant="fade" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {portfolio.map((p, i) => (
            <div key={p.id} data-stagger={i % 3} className="cinematic img-hover-zoom aspect-[4/5] bg-cream-soft">
              {p.video ? (
                <video
                  src={p.video}
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="metadata"
                  className="w-full h-full object-cover"
                />
              ) : (
                <img src={p.image} alt="" className="w-full h-full object-cover" />
              )}
            </div>
          ))}
        </Reveal>

        <Reveal variant="up" className="mt-16 text-center">
          <Link to="/contact" className="inline-flex items-center gap-2 text-[11px] tracking-luxury uppercase text-dark border border-dark px-8 py-4 hover:bg-dark hover:text-cream transition-colors duration-300 group">
            {t('cta.discussProject')}
            <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>
    </main>
  );
}
